import React, { Component } from 'react';
import {MDBNavLink} from 'mdbreact';
import './ItemList.css';
import ListedItems from '../components/ListedItems'
import {ProductConsumer} from '../context';

class Tablets extends Component {
    render() {
        return (
            <div>
                <div className="container">
                    <div className="d-flex flex-row">
                        <MDBNavLink to="../" className="p-0 m-0"><i class=" my-5 pt-2 pr-3 fas fa-arrow-left"></i></MDBNavLink>
                        <h1 className="field my-5">Tablets</h1>
                    </div>
                    <div className="my-5">
                        <ProductConsumer>
                            {value =>{
                                return value.products.filter(k=>k.category==="Tablets").map(product =>{
                                return <ListedItems key={product} products={product}/>;
                                })
                            }}
                        </ProductConsumer>
                    </div>
                </div>
            </div>
        );
    }
}

export default Tablets;